module.exports = __webpack_public_path__ + "img/frame14_current.dc87d372.png";